import { Injectable, NgZone } from '@angular/core';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';
import { Events } from '../helpers/events';

import { PlatformService } from "./platform.service";

@Injectable({
    providedIn: 'root'
})
export class RouterExtService {

    private previousUrl: string = undefined;
    public currentUrl: string = undefined;
    private history: string[] = [];

    public backNavigation: boolean = false;

    constructor(
        private plt: PlatformService,
        private router: Router,
        public ngZone: NgZone,
        private appEvents: Events
    ) {
        this.currentUrl = this.router.url;
        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (!this.backNavigation
                    && this.currentUrl != event.url
                    && this.currentUrl != "/"
                    && this.currentUrl != this.history[this.history.length - 1]
                ) {
                    this.history.push(this.currentUrl);
                }
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
                this.backNavigation = false;
            }
        });
    }

    public softNavigate(url?: string, replace = false) {
        if (!url) {
            url = this.currentUrl;
            this.history.push(this.currentUrl);
        }
        // solve navigation for iframes
        let iframe = <HTMLIFrameElement>document.querySelector('iframe#networking');
        if (!(window===window.parent) && iframe) {
            // do nothing
            // if (replace) {
            //     iframe.contentWindow.history.replaceState({}, '', `${url}`);
            // } else {
            //     iframe.contentWindow.history.pushState({}, '', `${url}`);
            // }
        } else {
            if (replace) {
                window.history.replaceState({}, '', `${url}`);
            } else {
                window.history.pushState({}, '', `${url}`);
            }
        }
        if (!this.backNavigation
            && this.currentUrl != url
            && this.currentUrl != "/"
            && this.currentUrl != this.history[this.history.length - 1]
        ) {
            this.history.push(this.currentUrl);
        }
        this.previousUrl = this.currentUrl;
        this.currentUrl = url;
        this.appEvents.publish('route:changed');
    }

    public softBack(updateHistory: boolean = false) {
        let iframe = <HTMLIFrameElement>document.querySelector('iframe#networking');
        if (!(window===window.parent) && iframe) {
            // do nothing
            // iframe.contentWindow.history.back();
        } else {
            window.history.back();
        }

        if (updateHistory) {
            this.popHistory();
        }
    }

    public popHistory() {
        this.currentUrl = this.previousUrl;
        this.previousUrl = this.history.pop();
    }

    public resetHistory() {
        this.history = [];
    }

    public emptyHistory(): boolean {
        return this.previousUrl == undefined;
    }


    public getPreviousUrl() {
        return this.previousUrl;
    }

    public canGoBack(): boolean {
        if (this.history.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    public back() {
        if (this.history.length > 0) {
            this.backNavigation = true;
            this.ngZone.run(() => {
                this.router.navigate([this.history.pop()]);
            });
        } else {
            // go home...
            //this.router.navigate([this.plt.defaultLink + 'home/info/matching']);
        }
    }
}
